export function usePartnerState(){

    const getState = () => {
        return useState<string>('partner-state', () => 'module')
    }

    const setStateValue = (value:string) => {
        const state = getState();

        state.value = value;
    }

    return {
        getState,
        setStateValue
    }

}